// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1778":"0279a0065afdb1e6","5882":"2125889e8b5508dd","8208":"4d150d5cf185b3b2"}[chunkId] + ".js";
};